import moment from 'moment'


/**
 * Format timestamp.
 *
 * @param {time} timestamp - timestamp to format
 * @returns {string} formattedTimestamp // e.g. Sep 06, 11:24 PM
 */
export default timestamp => typeof timestamp === 'number' ? moment(timestamp).format('MMM DD, h:mm A') : timestamp



// WEBPACK FOOTER //
// ./src/utils/formatTimestamp.js